import {Rating} from 'components/Rating';
import {Typography} from 'components/Typography';
import {PLURAL_GRADE_WORDS} from 'modules/products/constants';
import {pluralReviewsText} from 'modules/products/utils';
import {ProductStickyHeaderPageName, REVIEWS_CODE} from 'modules/product-card/constants';
import classNames from 'classnames';
import {FC, useMemo} from 'react';
import style from './style.module.scss';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import Link from 'next/link';
import {useProductRoutes} from 'core/modules/routing/hooks/useProductRoute';

interface IProps {
    page?: ProductStickyHeaderPageName;
}

const {Product} = ProductStickyHeaderPageName;

export const ProductRatingStickyHeader: FC<IProps> = ({page = Product}) => {
    const productData = useAppSelector(selectProductData);
    const {code: productCode, ratings, reviewsCount} = productData || {};

    const {
        product: {url},
    } = useProductRoutes();

    const reviewRating = useMemo(() => {
        return ratings?.find(({code}) => REVIEWS_CODE === code)?.value ?? 0;
    }, [ratings]);

    return (
        <div className={classNames(style.main, !reviewsCount ? style.noReviews : '')}>
            <a className={style.ratingBody} data-skeleton-item={true} href={'#reviews'}>
                <Rating className={style.ratingComponent} isReadOnly={true} rate={reviewRating} />
                {Product === page ? (
                    <>
                        <Typography className={style.ratingReviewText} variant={'label-14-m'}>
                            {pluralReviewsText({count: reviewsCount, words: PLURAL_GRADE_WORDS})}
                        </Typography>
                        <Typography className={style.noReviewsText} variant={'label-14-m'}>
                            Оставить отзыв
                        </Typography>
                    </>
                ) : (
                    <Link href={url({id: productCode ?? ''})}>
                        <Typography className={style.moreLink} element={'div'} variant={'label-14-r-fluid'}>
                            Подробнее о товаре
                        </Typography>
                    </Link>
                )}
            </a>
        </div>
    );
};
